export class ApiEndPoints {
    //Summary
    //Call api to login the user
    loginApiUrl = 'api/Auth/LogIn';
    HandleLogin = 'api/Auth/HandleLogin';
    MatchOTP = 'api/Auth/MatchOTP';
    VerifyNewIp = 'api/Auth/VerifyNewIp';
    CheckLoginTokenEXpiry = 'api/Auth/CheckLoginTokenEXpiry';
    //Summary
    //Call api to validate token
    validateUser = 'api/Auth/ValidateToken';

    ValidateUserInvite ='api/ManageUser/ValidateUserInvite';
    UserRegistrationInvite='api/ManageUser/UserRegisterationInvite';
    VerifyEmail = "api/ManageUser/VerifyEmail";
    userLogin = "api/Auth/UserLogin";
}

